module.exports = __webpack_public_path__ + "img/s2.90a1661e.png";